import { render, staticRenderFns } from "./OperationScrap.vue?vue&type=template&id=1b0a013d&scoped=true"
import script from "./OperationScrap.vue?vue&type=script&lang=js"
export * from "./OperationScrap.vue?vue&type=script&lang=js"
import style0 from "./OperationScrap.vue?vue&type=style&index=0&id=1b0a013d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0a013d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b0a013d')) {
      api.createRecord('1b0a013d', component.options)
    } else {
      api.reload('1b0a013d', component.options)
    }
    module.hot.accept("./OperationScrap.vue?vue&type=template&id=1b0a013d&scoped=true", function () {
      api.rerender('1b0a013d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Operation/OperationScrap/OperationScrap.vue"
export default component.exports